export const teamStatusesNames = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    ARCHIVED: 'Archived',
    PENDING: 'Pending',
};
